// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"src-components-Dashboard-__circle-chart__wrapper--1g9Ld","common":"src-components-Dashboard-__circle-chart__common--3mOsA","chart":"src-components-Dashboard-__circle-chart__chart--1_4oo src-components-Dashboard-__circle-chart__common--3mOsA","label":"src-components-Dashboard-__circle-chart__label--1FMzD src-components-Dashboard-__circle-chart__common--3mOsA"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Dashboard/circle-chart.css
// module id = 1963
// module chunks = 0